// src/hooks/useToast.js
import { createContext, useContext } from 'react';

export const ToastContext = createContext(null);

const noop = () => {};
const fallbackToast = {
  show: noop,
  success: noop,
  error: noop,
  warning: noop,
  info: noop,
};

export default function useToast() {
  return useContext(ToastContext) || fallbackToast;
}
